<template>
    <div id="transactionCompletePage" class="container bg-white px-0 py-5">
        <div
            v-if="this.$root.$data.transaction.ecommercePlatform === 'Shopify'"
            class="d-flex flex-column p-2"
        >
            <div class="mt-4 mb-2">
                <div
                    class="d-flex align-items-start rounded-sm warningBg p-2 mb-2"
                >
                    <img
                        alt=""
                        src="/img/hcpay/warning-icon.svg"
                        class="warningIcon img-responsive mr-3"
                    />
                    <span class="font-xs xD-css">
                        Please do not close this screen. You will be redirected
                        back to the merchant automatically. Taking too long?
                        Click ‘Back to Merchant’ below.
                    </span>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column align-items-center text-center p-2">
            <img
                alt=""
                src="/img/hcpay/transaction-complete-icon-2.svg"
                class="transactionCompleteIcon img-responsive"
            />
            <span
                class="font-md font-weight-bold text-gray-dk text-capitalize my-3"
                >Transaction Complete!</span
            >
            <span class="font-sm text-secondary">
                Your purchase has been confirmed and will be
                <br />
                processed by the merchant for delivery.
            </span>
            <span
                v-if="$root.$data.transaction.paymentOption === 'hc_loan'"
                class="font-lg font-weight-bold text-gray-dk mt-4 mb-2"
                >₱
                {{
                    $root.$data.transaction.installmentDetails
                        .monthlyInstallment
                }}/month</span
            >
            <span v-else class="font-lg font-weight-bold text-gray-dk mt-4 mb-2"
                >₱ {{ amount }}/month</span
            >
            <span class="font-xs text-secondary my-2"
                >has been successfully paid to</span
            >
            <span
                class="font-sm font-weight-bold text-gray-dk text-capitalize mb-3"
            >
                {{ $root.$data.transaction.merchantName }}
            </span>
            <span class="font-xs text-secondary">from your</span>
            <span class="font-sm font-weight-bold text-gray-dk mt-2 mb-3"
                >Home Credit Installment</span
            >
        </div>
        <hr class="customDivider" />
        <div class="px-4 mt-4">
            <payment-summary-opg class="mx-auto" :dropdown="true" />
        </div>
        <hr class="customDivider" />
        <div
            v-if="
                newTransactionDetails.hasOwnProperty('installmentDetails') &&
                newTransactionDetails.installmentDetails
            "
            class="px-4 mt-4 mb-5"
        >
            <installment-plan
                :installmentDetails="newTransactionDetails.installmentDetails"
                class="mx-auto"
                :dropdown="true"
            />
        </div>
        <div class="d-flex flex-column justify-content-center text-center px-5">
            <span
                class="font-xs font-weight-bold text-gray-dk text-capitalize mb-2"
                >Reference No.
                {{ $root.$data.transaction.referenceNumber }}</span
            >
            <span class="font-xs font-weight-bold text-secondary mb-4">{{
                newTransactionDetails.transUpdateTime | moment
            }}</span>
            <div class="px-5">
                <button
                    type="button"
                    id="transactionCompleteBackToStore"
                    @click="backToStore"
                    class="btn btn-success btn-block rounded-lg py-2 mb-3"
                >
                    Back to Merchant
                </button>
            </div>

            <button
                type="button"
                id="transactionCompleteShareFeedback"
                class="btn btn-link-success font-weight-bold font-sm text-green text-capitalize"
                @click="openQualtrics()"
                v-if="qualtricsEnabled"
            >
                Share Feedback
            </button>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import cancelRequest from "./cancel_request_opg2.0.vue";
import { ERROR } from "../../mixins/error_codes.js";
export default {
    components: {
        cancelRequest,
    },
    data() {
        const qualtricsBtnEl = document.getElementById("QSIFeedbackButton-btn");
        return {
            qualtricsEnabled: !!qualtricsBtnEl,
            newTransactionDetails: {},
        };
    },
    async created() {
        this.$root.$data.complete = true;
        this.$root.$data.previousView = "transaction-complete";

        let g4Params = {
            ip: this.$root.transaction.ipAddress,
            user_agent: this.$root.$data.analyticsData.userAgent,
            phone: this.$root.$data.analyticsData.phone,
            operating_system:
                this.$root.$data.analyticsData.operatingSystem.name +
                "V" +
                this.$root.$data.analyticsData.operatingSystem.version,
            browser:
                this.$root.$data.analyticsData.browser.name +
                "V" +
                this.$root.$data.analyticsData.browser.version,
            transaction_type:
                this.$root.$data.transaction.referenceNumber.substring(0, 2),
            transaction_reference: this.$root.$data.transaction.referenceNumber,
        };
        this.$root.triggerG4Event("transaction_complete_page", g4Params);

        const { data } = await axios.post(
            "opg/getNewTransactionDetails",
            this.$root.$data
        );
        if (data) {
            this.newTransactionDetails = data;
        } else {
            this.newTransactionDetails = $root.$data.transaction;
        }

        if (this.$root.$data.transaction.ecommercePlatform === "Shopify") {
            if (
                this.$root.transaction.hasOwnProperty("successUrl") ||
                this.$root.transaction.successUrl != "undefined"
            ) {
                window.location.href = this.$root.transaction.successUrl;
            } else {
                vm.$root.error = ERROR.TECHNICAL_PROBLEM;
            }
        }
    },
    computed: {
        amount() {
            let val = (this.$root.$data.transaction.amount / 1)
                .toFixed(2)
                .replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    },
    methods: {
        backToStore() {
            if (
                this.$root.transaction.hasOwnProperty("successUrl") ||
                this.$root.transaction.successUrl != "undefined"
            ) {
                window.location.href = this.$root.transaction.successUrl;
            } else {
                vm.$root.error = ERROR.TECHNICAL_PROBLEM;
            }
        },
        changeView(view) {
            this.$root.$data.view = view;
        },
        openQualtrics() {
            const qualtricsBtnEl = document.getElementById(
                "QSIFeedbackButton-btn"
            );
            if (!qualtricsBtnEl) {
                return;
            }
            qualtricsBtnEl.click();
        },
    },
    filters: {
        moment: function (date) {
            return moment(date).format("DD MMM YYYY | hh:mm a").toUpperCase();
        },
    },
};
</script>
<style scoped>
.transactionCompleteIcon {
    height: auto;
    width: 7rem;
}

.xD-css {
    text-align: left;
    font: normal normal normal 12px/18px Roboto;
    letter-spacing: 0px;
    color: #00000099;
    opacity: 1;
}

.warningIcon {
    height: auto;
    width: 1.5rem;
}

.warningBg {
    background-color: #fff3e0;
}
</style>
